export default "__VITE_ASSET__Dy0J219b__"